import AUTH from './auth.api';
import CANDIDATE_SETTINGS from './candidate.settings.api';
import CANDIDATE from './candidate.api';
import STUDENT from './student.api';
import STUDENT_SETTINGS from './student.settings.api';

const CANDIDATE_API = {
	AUTH,
	SETTINGS: CANDIDATE_SETTINGS,
	USER: CANDIDATE
};

const STUDENT_API = {
	AUTH,
	SETTINGS: STUDENT_SETTINGS,
	USER: STUDENT
};

const APP_API = {
	STUDENT: STUDENT_API,
	CANDIDATE: CANDIDATE_API
};

export default APP_API;
